import React from "react";
import { usePublicLanguage } from "../context/PublicLanguage";
import { translate } from "../lib/publicTranslations";
import { Link } from "react-router-dom";

const LABELS = {
  ai: "AI Dish",
  robotics: "Robot Dish",
  cybersecurity: "Cyber Dish",
  "future-tech": "Future Tech",
  business: "Tech Business",
  guides: "Guides",
};

export function categoryLabel(slug, language = "en") {
  return translate(LABELS[slug] || slug, language);
}

export default function CategoryTag({ category, className = "", asLink = true, small = false }) {
  const { language } = usePublicLanguage();
  const label = categoryLabel(category, language);
  const base = `td-eyebrow inline-flex items-center ${small ? "" : ""}`;
  const content = <span style={{ color: "#FF8A1F", fontSize: small ? "0.6rem" : "0.68rem" }}>{label}</span>;
  if (!asLink) return <span className={`${base} ${className}`}>{content}</span>;
  return (
    <Link to={`/${category}`} className={`${base} hover:opacity-80 transition-opacity ${className}`} data-testid={`cat-tag-${category}`}>
      {content}
    </Link>
  );
}
